// custom events
import {
  CONFIRM_MODAL,
  DELETE_CONFIRM_MODAL,
  INFO_MODAL,
  LOGOUT_USER,
  REFECTH_QUERY,
} from './globalConstants';

export const logoutUserEvent = new CustomEvent(LOGOUT_USER);

export const deleteConfirmModalEvent = (state) =>
  new CustomEvent(DELETE_CONFIRM_MODAL, {
    detail: state,
  });

export const confirmModalEvent = (state) =>
  new CustomEvent(CONFIRM_MODAL, {
    detail: state,
  });

// Opens the popup that only tells the user something -- see InfoModal.
export const infoModalEvent = (state) =>
  new CustomEvent(INFO_MODAL, {
    detail: state,
  });

export const refetchQuery = (queryKey) =>
  new CustomEvent(REFECTH_QUERY, {
    detail: { queryKey },
  });
